import { render, staticRenderFns } from "./approval-recall.vue?vue&type=template&id=678c1268&scoped=true&"
import script from "./approval-recall.vue?vue&type=script&lang=js&"
export * from "./approval-recall.vue?vue&type=script&lang=js&"
import style0 from "./approval-recall.vue?vue&type=style&index=0&id=678c1268&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678c1268",
  null
  
)

export default component.exports